import Box from '@mui/material/Box';
import AppButton from './AppButton';
import { Badge } from './Bits';

/**
 * Prev / page-of / Next control. Deliberately page-number based so it maps 1:1 onto a
 * paginated API (`?search=&page=1`) when the backend arrives.
 */
export default function Pagination({ page, pages, onChange }) {
  return (
    <Box sx={{ display: 'flex', gap: 0.75, alignItems: 'center' }}>
      <AppButton mini disabled={page <= 1} onClick={() => onChange(page - 1)}>
        ‹ Prev
      </AppButton>
      <Badge>
        Page {page} / {pages}
      </Badge>
      <AppButton mini disabled={page >= pages} onClick={() => onChange(page + 1)}>
        Next ›
      </AppButton>
    </Box>
  );
}
